import { useMemo } from 'react';
import AnnotationContext from "../context/AnnotationContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function Annotation(_ref) {
  let {
    x,
    y,
    dx,
    dy,
    children
  } = _ref;
  const value = useMemo(() => ({
    x,
    y,
    dx,
    dy
  }), [x, y, dx, dy]);
  return /*#__PURE__*/_jsx(AnnotationContext.Provider, {
    value: value,
    children: children
  });
}